import { render } from "./MaCaisse.vue?vue&type=template&id=235da725&scoped=true"
import script from "./MaCaisse.vue?vue&type=script&lang=js"
export * from "./MaCaisse.vue?vue&type=script&lang=js"

import "./MaCaisse.vue?vue&type=style&index=0&id=235da725&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-235da725"]])

export default __exports__